export const replaceQueryWindowHistoryState = (query: string, preserveHash = false): void => {
  if (typeof window !== 'undefined') {
    const hash = preserveHash ? window.location.hash : '';
    if (query.length > 0) window.history.replaceState({}, '', `${window.location.pathname}${query}${hash}`);
    else window.history.replaceState(null, '', `${window.location.pathname}${hash}`);
  }
};
